import React, { useEffect, useState } from "react";
import { formatNumberInput, parseFormattedNumber } from "../utils/numberFormat";

function EditableText({ initialText, isEnabled, onSave, numeric = false, allowDecimal = false }) {
  const [text, setText] = useState(
    numeric ? formatNumberInput(initialText, { allowDecimal }) : initialText
  );

  // سینک کردن استیت با پراپ جدید اگر initialText تغییر کرد
  useEffect(() => {
    setText(numeric ? formatNumberInput(initialText, { allowDecimal }) : initialText);
  }, [initialText, numeric, allowDecimal]);

  const handleBlur = () => {
    const nextValue = numeric
      ? parseFormattedNumber(text, { allowDecimal })
      : text;

    if (onSave && nextValue !== String(initialText ?? "")) {
      onSave(nextValue);
    }
  };

  // اگر isEnabled نال یا undefined باشد، پیش‌فرض را true در نظر می‌گیریم مگر اینکه صریحا false باشد
  const isDisabled = isEnabled === false;

  return (
    <input
      value={text}
      onChange={(e) =>
        setText(numeric ? formatNumberInput(e.target.value, { allowDecimal }) : e.target.value)
      }
      onBlur={handleBlur}
      disabled={isDisabled}
      className="InpoterTablo"
      placeholder={initialText}
      inputMode={numeric ? (allowDecimal ? "decimal" : "numeric") : undefined}
    />
  );
}

export default EditableText;
